// src/components/Steps/GenresStep.tsx
import { useEffect, useState } from 'react';
import { useOnboardingStore } from '../store/useOnboardingStore';
import { Link, useNavigate } from 'react-router-dom';
import { useUserStore } from '../store/useUserStore';
import { useProfileUpdateStore } from '../store/useProfileUpdateStore';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuthStore from '../store/useAuthStore';



const GenresEdit = () => {
    const {
        genres,
        fetchGenres,  
       searchQuery,
        setSearchQuery,
        genresToShow,
        showMoreGenres,
        showLessGenres,
       
      } = useOnboardingStore();
    const user = useUserStore((state) => state.user);
    const authStore = useAuthStore.getState();
    const navigate = useNavigate();
    const userId= authStore.user.id;
    const { updateProfile } = useProfileUpdateStore();
    const [selectedGenres, setSelectedGenres] = useState<number[]>([]);
    const getUserDetails = useUserStore((state) => state.getUserDetails);
       // Filter genres by search query
  const filteredGenres = genres.filter((genre) =>
    genre.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSave = async (e:any) => {
    e.preventDefault();
  const updatedData = {
        genres: {
            selectedGenres,
            
          }
    };


   try {
    await updateProfile(user.id, updatedData);
    getUserDetails(user.id); 

    toast.success("Interests updated successfully!");
    navigate("/myprofile?edit=interest");
    // setActiveSection(null); // Uncomment to close
  } catch (error) {
    console.log(error);
    
    toast.error("Failed to Interests. Please try again.");
  }
  };

  console.log('selectedGenres',selectedGenres);
  useEffect(() => {
    if (user) {
     
      console.log('user.genres',user);
      
      setSelectedGenres(user.genres?.split(',').map(Number) || []);
    }
  }, [user]);
  
  useEffect(() => {
    fetchGenres();
    getUserDetails(userId); 
  }, [fetchGenres]);

  // Group genres by title (category)
  const groupedGenres = filteredGenres.reduce((acc: Record<string, any[]>, genre) => {
    if (!acc[genre.title]) {
      acc[genre.title] = [];
    }
    acc[genre.title].push(genre);
    return acc;
  }, {});

  return (
    <>


    <section className="bg-light onboarding_main_wraper py-60">
        <div className="container">
        
            <div className="row">
                <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">
                <div className="dp_profile_top_bredcrumb mb-4">
                    <Link to="/myprofile" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </Link>
                    
                </div>
                    <form className="onboarding_form">
                        <div className="form_group">
                            <label className="form-label w-100">Interest Categories</label>
                            <p>Let’s make sure you connect with people who vibe with your style. Choose the interests that
                                best describe your personality.
                            </p>
                            <div className="row">
                                <div className="col-md-8">
          
                                    <input   value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="form-control" placeholder="Search" />
                                </div>
                            </div>
                        </div>

                        {filteredGenres.length > 0 ? (
                                  <>
                                    {Object.entries(groupedGenres).slice(0, genresToShow).map(([title, items]) => {
                                      // Split items into two equal columns
                                      const midIndex = Math.ceil(items.length / 2);
                                      const leftColumn = items.slice(0, midIndex);
                                      const rightColumn = items.slice(midIndex);

                                      return (
                                        <div key={title} className="form_group onboarding_genres_checkboxwrpr">
                                          <label className="form-label w-100">{title}</label>
                                          <div className="row">
                                            <div className="col-md-6">
                                              {leftColumn.map((item) => (
                                                <div key={item.id} className="form-check">
                                                  <input
                                                    checked={selectedGenres.includes(item.id)}
                                                    onChange={() => {
                                                        if (selectedGenres.includes(item.id)) {
                                                          setSelectedGenres(selectedGenres.filter(id => id !== item.id));
                                                        } else {
                                                          setSelectedGenres([...selectedGenres, item.id]);
                                                        }
                                                      }}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`option-${item.id}`}
                                                  />
                                                  <label className="form-check-label" htmlFor={`option-${item.id}`}>
                                                    {item.name}
                                                  </label>
                                                </div>
                                              ))}
                                            </div>
                                            <div className="col-md-6">
                                              {rightColumn.map((item) => (
                                                <div key={item.id} className="form-check">
                                                  <input
                                                    checked={selectedGenres.includes(item.id)}
                                                    onChange={() => {
                                                        if (selectedGenres.includes(item.id)) {
                                                          setSelectedGenres(selectedGenres.filter(id => id !== item.id));
                                                        } else {
                                                          setSelectedGenres([...selectedGenres, item.id]);
                                                        }
                                                      }}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`option-${item.id}`}
                                                  />
                                                  <label className="form-check-label" htmlFor={`option-${item.id}`}>
                                                    {item.name}
                                                  </label>
                                                </div>
                                              ))}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                    {Object.entries(groupedGenres).length > genresToShow ? (
                                      <div className="text-center">
                                        <a
                                          href="javascript:void(0)"
                                          onClick={showMoreGenres}
                                          className="text-primary font500 d-inline-block"
                                        >
                                          See More
                                        </a>
                                      </div>
                                    ) : genresToShow > 5 && (
                                      <div className="text-center">
                                        <a
                                          href="javascript:void(0)"
                                          onClick={showLessGenres}
                                          className="text-muted font500 d-inline-block"
                                        >
                                          See Less
                                        </a>
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <p>No interests available.</p>
                                )}


                       

                       


                        <div className="d-flex justify-content-center  mt-5">
                        <button
                            onClick={handleSave}
                            className="btn btn-outline-primary w-50 mt-3"
                          >
                            Save Changes
                          </button>
                        </div>

            



                </form>

            </div>
        </div>
        </div>
    </section>
    
   

    </>
  );
};

export default GenresEdit;


